// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OJHt","largestCol":"styles_largestCol__2awg0","smallestCol":"styles_smallestCol__1ERPG"};